import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/*
 * @Author: Phoenix
 * @Date: 2020-05-01 10:56:51
 * @LastEditTime: 2021-01-18 17:32:24
 * @Description:
 * @FilePath: /ups-single-window-web/src/router/permission.js
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
 */
import store from '@/store';
import routesAdmin from '@/router/modules/admin';
var permissionRoutes = [];
function filterAsyncRoutes(routes) {
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (tmp.meta && tmp.meta.permissionTag && hasAccess(tmp.meta.permissionTag)) {
      permissionRoutes.push(tmp);
    }
    if (tmp.children) {
      filterAsyncRoutes(tmp.children);
    }
  });
}
export function hasAccess(permissionTag) {
  var userPermission = store.getters['user/userPermission'];
  return userPermission.findIndex(function (v) {
    return v.permissionCode === permissionTag;
  }) > -1;
}
export function nextPage(permissionTag) {
  filterAsyncRoutes(routesAdmin);
  return permissionRoutes.find(function (v) {
    return v.meta.permissionTag !== permissionTag;
  }).path;
}